var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "chat-messages"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageLoading),
      expression: "messageLoading"
    }]
  }, [_c('img', {
    style: ({
      position: 'absolute',
      top: '40%',
      left: '45%',
      'z-index': '1'
    }),
    attrs: {
      "src": require("../../assets/messageLoading.gif")
    }
  })]), _vm._l((_vm.messages), function(msg, index) {
    return _c('div', {
      key: msg.id,
      staticClass: "message-root",
      class: _vm.senderType == msg.sender.role ? 'mine' : 'other-user',
      attrs: {
        "data-sender-role": msg.sender.role,
        "data-context": msg.context
      }
    }, [(msg.content.isLoading) ? _c('v-layout', [_c('img', {
      attrs: {
        "src": require("../../assets/loading.gif")
      }
    })]) : _vm._e(), (_vm.loadingDisplayMessageText(msg)) ? _c('v-layout', [(msg.sender.role == 'bot') ? _c('v-icon', {
      staticClass: "op-icon"
    }, [_vm._v("smart_toy")]) : (msg.sender.role != 'user') ? _c('v-icon', {
      staticClass: "op-icon"
    }, [_vm._v("account_circle")]) : _vm._e(), _c('div', {
      staticClass: "sender-name"
    }, [_vm._v(_vm._s(_vm.displaySenderName(msg.sender)))]), _c('div', {
      staticClass: "sender-room-id"
    }, [_vm._v(_vm._s(_vm.displayMessageRoomId(msg.sender.role)))]), _c('div', {
      staticClass: "sender-read",
      attrs: {
        "id": msg.id
      }
    })], 1) : _vm._e(), (_vm.loadingDisplayMessageText(msg)) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), ((msg.type === 'frequentlyQuestionSecond' && _vm.frequentlyQuestionFlg && msg.content.productCategory !== 'audio' && msg.content.productCategory !== 'projector' && msg.content.productCategory !== 'monitor')) ? _c('div', [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決した', index)
      },
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickFrequentlyQuestionAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決した")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('他のFAQを調べる', index)
      },
      attrs: {
        "text": "text",
        "value": "false",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickFrequentlyQuestionAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("他のFAQを調べる")])], 1) : _vm._e(), ((msg.type === 'frequentlyQuestionSecond' && _vm.frequentlyQuestionFlg && msg.content.productCategory === 'audio' || msg.content.productCategory === 'projector' || msg.content.productCategory === 'monitor')) ? _c('div', [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決した', index)
      },
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickFrequentlyQuestionAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決した")]), (!_vm.$props.isAfterBusinessHour) ? _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")]) : _vm._e(), (_vm.$props.isAfterBusinessHour) ? _c('v-btn', {
      attrs: {
        "text": "text",
        "primary": "primary"
      },
      on: {
        "click": function($event) {
          _vm.onClickFaqPageLink()
        }
      }
    }, [_vm._v("FAQサイトにアクセスする")]) : _vm._e()], 1) : _vm._e()]) : (msg.type == 'ButtonList') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, _vm._l((msg.content.buttons), function(btn) {
      return _c('v-btn', {
        key: btn.value,
        attrs: {
          "primary": "primary",
          "dark": "dark",
          "large": "large",
          "data-value": btn.value
        },
        on: {
          "click": function($event) {
            _vm.onClickButton(msg.content.type, btn)
          }
        }
      }, [_vm._v(_vm._s(btn.label))])
    }))]) : (msg.type == 'ButtonClick') ? _c('div', [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(msg.content.button.label))])]) : (msg.type == 'ProductCategorySelect' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, _vm._l((msg.content.categories), function(category) {
      return _c('v-btn', {
        key: category.value,
        class: {
          'button-selected': _vm.isButtonSelected(category.label, index)
        },
        attrs: {
          "large": "large",
          "primary": "primary",
          "data-value": category.value,
          "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
        },
        on: {
          "click": function($event) {
            _vm.onClickProductCategory(category)
          }
        }
      }, [_vm._v(_vm._s(category.label))])
    }))]) : (msg.type == 'TroubleCategorySelect' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, _vm._l((msg.content.categories), function(category) {
      return _c('v-btn', {
        key: category.value,
        class: {
          'button-selected': _vm.isButtonSelected(category.label, index)
        },
        attrs: {
          "large": "large",
          "primary": "primary",
          "data-value": category.value,
          "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
        },
        on: {
          "click": function($event) {
            _vm.onClickTroubleCategory(category)
          }
        }
      }, [_vm._v(_vm._s(category.label))])
    }))]) : (msg.type == 'RequestProductCode' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "howto-check-product-number"
    }, [_c('a', {
      attrs: {
        "href": _vm.getProductCodeFaqUrl(),
        "target": "_blank"
      }
    }, [_vm._v(" 製造番号（シリアルナンバー）を確認したい")])]), _c('v-layout', {
      staticClass: "align-center justify-start row fill-height"
    }, [_c('v-text-field', {
      key: "product-code",
      attrs: {
        "solo": "solo",
        "label": "製品形名",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      model: {
        value: (_vm.productCode),
        callback: function($$v) {
          _vm.productCode = $$v
        },
        expression: "productCode"
      }
    }), _c('v-btn', {
      class: {
        'button-disabled': _vm.validInputProductCode
      },
      attrs: {
        "small": "small",
        "primary": "primary",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg || _vm.validInputProductCode
      },
      on: {
        "click": function($event) {
          _vm.onClickSubmitProductCode()
        }
      }
    }, [_vm._v("次へ")])], 1), (_vm.validInputProductCode) ? _c('div', {
      staticClass: "error-message"
    }, [_vm._v("10文字以内で入力してください")]) : _vm._e()], 1) : (msg.type == 'frequentlyQuestion' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "answerData"
    }, [_c('div', {
      staticClass: "answers"
    }, _vm._l((msg.content.answers), function(answers, index) {
      return _c('v-card', {
        key: answers.url,
        attrs: {
          "outlined": "outlined",
          "tile": "tile",
          "link": "link",
          "hover": "hover"
        },
        on: {
          "click": function($event) {
            _vm.onClickAnswerCard(answers)
          }
        }
      }, [_c('v-card-title', [_vm._v(_vm._s(answers.link_text))])], 1)
    }))])]) : (msg.type == 'chatbotFixedMessages' && _vm.frequentlyQuestionFlg) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    })]) : (msg.type == 'Answer' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _vm._l((msg.content.answers), function(answers, index) {
      return _c('div', {
        staticClass: "answerData"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index <= 0),
          expression: "index <= 0"
        }],
        staticClass: "answers",
        attrs: {
          "data-type": msg.content.type
        }
      }, _vm._l((answers), function(answer) {
        return _c('v-card', {
          key: answer.url,
          attrs: {
            "outlined": "outlined",
            "tile": "tile",
            "link": "link",
            "hover": "hover"
          },
          on: {
            "click": function($event) {
              _vm.onClickAnswerCard(answer)
            }
          }
        }, [_c('v-card-title', [_vm._v(_vm._s(answer.link_text))])], 1)
      }))])
    }), (msg.content.answers.length >= 2) ? _c('div', {
      staticClass: "displayFaq"
    }, [_c('v-card', {
      staticClass: "answerFaq"
    }, [_c('v-card-actions', [_c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!msg.content.faqIsLoading),
        expression: "!msg.content.faqIsLoading"
      }]
    }, [_c('v-btn', {
      staticClass: "nextFaq",
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickNextFaqButton($event)
        }
      }
    }, [_vm._v("次の5件")])], 1), _c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.content.faqIsLoading),
        expression: "msg.content.faqIsLoading"
      }]
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/loading.gif")
      }
    })])], 1)], 1)], 1) : _vm._e(), _c('div', {
      staticClass: "feedback"
    }, [_c('v-card', [_c('v-card-title', [_vm._v("お客様の問題は解決しましたか？　対象がない場合は、あらためてご質問を入力してください。")]), _c('v-card-actions', [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決した', index)
      },
      attrs: {
        "primary": "primary",
        "elevation": "2",
        "value": "true",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決した")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('解決しなかった', index)
      },
      attrs: {
        "error": "error",
        "elevation": "2",
        "value": "false",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAnswerFeedbackButton($event)
        }
      }
    }, [_vm._v("解決しなかった")])], 1)], 1)], 1)], 2) : (msg.type == 'EndOfFaq' && !msg.content.isLoading) ? _c('div', [(msg.content.no_dispaly_op_call) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")]), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "text",
        "primary": "primary"
      },
      on: {
        "click": function($event) {
          _vm.onClickFaqPageLink()
        }
      }
    }, [_vm._v("FAQサイトにアクセスする")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")])], 1)]) : _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")]), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('チャットボットにあらためて質問する', index)
      },
      attrs: {
        "primary": "primary",
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAskChatbot($event)
        }
      }
    }, [_vm._v("チャットボットにあらためて質問する")]), (msg.content.finished) ? _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg || _vm.$props.isAfterBusinessHour
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")]) : _vm._e()], 1), (msg.content.finished && _vm.$props.isAfterBusinessHour) ? _c('v-btn', {
      attrs: {
        "text": "text",
        "primary": "primary"
      },
      on: {
        "click": function($event) {
          _vm.onClickFaqPageLink()
        }
      }
    }, [_vm._v("FAQサイトにアクセスする")]) : _vm._e()], 1)]) : (msg.type == 'EndFrequentlyOfFaq' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")])]) : (msg.type == 'Link') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('div', {
      staticClass: "link"
    }, [_c('a', {
      attrs: {
        "href": msg.content.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(msg.content.link_text))])])]) : (msg.type == 'ProductList') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-expansion-panel', {
      staticClass: "product-list"
    }, _vm._l((msg.content.kinds), function(kind) {
      return _c('v-expansion-panel-content', {
        key: kind.id
      }, [_c('div', {
        slot: "header"
      }, [_vm._v(_vm._s(kind.name))]), _c('v-layout', {
        attrs: {
          "row": "row",
          "wrap": "wrap"
        }
      }, _vm._l((kind.products), function(product) {
        return _c('v-flex', {
          key: product.id,
          staticClass: "product-container",
          attrs: {
            "xs12": "xs12",
            "sm6": "sm6",
            "md4": "md4",
            "lg": "lg",
            "3": "3",
            "xl2": "xl2"
          }
        }, [(product.img_url && 0 < product.img_url.length) ? _c('span', [_c('img', {
          staticClass: "product-img",
          attrs: {
            "src": product.img_url
          }
        })]) : _c('span', {
          staticClass: "grey--text darken-2"
        }, [_vm._v("no image")]), _c('v-btn', {
          attrs: {
            "block": "block"
          },
          on: {
            "click": function($event) {
              _vm.onClickProduct(product)
            }
          }
        }, [_vm._v(_vm._s(product.name))])], 1)
      }))], 1)
    }))], 1) : (msg.type == 'ProductSelect') ? _c('div', [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(msg.content.product_name))])]) : (msg.type == 'ProductCompare') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.createProductCompareHeaders(msg.content.products),
        "items": _vm.createProductCompareItems(msg.content.specs),
        "hide-actions": "hide-actions"
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.prop_url) ? _c('span', [_c('a', {
            attrs: {
              "href": props.item.prop_url,
              "target": "_blank"
            }
          }, [_vm._v(_vm._s(props.item.prop_name))])]) : _c('span', [_vm._v(_vm._s(props.item.prop_name))])]), _vm._l((msg.content.products), function(product) {
            return _c('td', {
              key: product.product_id,
              staticClass: "text-xs-left"
            }, [_vm._v(_vm._s(props.item[product.product_id]))])
          })]
        }
      }])
    })], 1) : (msg.type == 'SelectOperationMode' && !msg.content.isLoading) ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }, [_vm._v("msg.content.text")]), _c('div', {
      staticClass: "buttons",
      attrs: {
        "data-type": msg.content.type
      }
    }, [_c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('チャットボットに質問する', index)
      },
      attrs: {
        "primary": "primary",
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg
      },
      on: {
        "click": function($event) {
          _vm.onClickAskFrequentlyFaqChatbot($event)
        }
      }
    }, [_vm._v("チャットボットに質問する")]), _c('v-btn', {
      staticClass: "button-font-size",
      class: {
        'button-selected': _vm.isButtonSelected('オペレーターによる対応を希望する', index)
      },
      attrs: {
        "text": "text",
        "disabled": !_vm.isMessageHead(msg) || _vm.closedRoomFlg || _vm.$props.isAfterBusinessHour
      },
      on: {
        "click": function($event) {
          _vm.callOperator($event)
        }
      }
    }, [_vm._v("オペレーターによる対応を希望する")])], 1)]) : (msg.type == 'FAQ') ? _c('div', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.displayMessageText(msg))
      }
    }), _c('v-expansion-panel', _vm._l((msg.content.faqs), function(faq) {
      return _c('v-expansion-panel-content', {
        key: faq.title
      }, [_c('div', {
        staticClass: "faq-title indigo--text darken-4",
        slot: "header"
      }, [_vm._v(_vm._s(faq.title))]), _c('v-card', [_c('v-card-text', {
        domProps: {
          "innerHTML": _vm._s(faq.content)
        }
      })], 1)], 1)
    }))], 1) : (msg.type == 'File') ? _c('div', [(_vm.messageIsImageFile(msg)) ? _c('span', [_c('a', {
      attrs: {
        "href": _vm.createFileURL(msg),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "file-img",
      attrs: {
        "src": _vm.createFileURL(msg)
      }
    })])]) : _c('span', [_c('v-icon', {
      staticClass: "file-icon indigo--text",
      domProps: {
        "textContent": _vm._s(_vm.messageIsPdfFile(msg) ? 'picture_as_pdf' : 'file_download')
      }
    }), _c('a', {
      attrs: {
        "href": _vm.createFileURL(msg),
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "file-size indigo--text"
    }, [_vm._v(_vm._s(msg.content.file.name) + " (" + _vm._s(_vm.toFileSizeString(msg.content.file.size)) + ")")])])], 1)]) : _vm._e()], 1)
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eae819ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./app-common-vue/src/components/ChatMessages/ChatMessages.pug
// module id = i6Ml
// module chunks = 1